import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PipesModule } from '@shared/pipes';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { ForgetPasswordComponent } from './components/forget-password/forget-password.component';
import { LoginComponent } from './components/login/login.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';


const routes: Routes = [
  { path: 'login', component: LoginComponent},
  { path: 'forget-password', component: ForgetPasswordComponent},
  { path: 'reset-password/:token', component: ResetPasswordComponent},
  { path: 'change-pwd', component: ChangePasswordComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes),
    PipesModule],
  exports: [RouterModule]
})
export class AuthRoutingModule {}
